import {
  QuestionScore,
  StudentActivityResponse,
} from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import {
  defaultCorrect,
  defaultUngraded,
} from '../calculateQuestionDefaultScore';

export const studentQuestionResponseScore = (
  response: StudentActivityResponse,
  question: QuizQuestion,
  questionscore: QuestionScore
) => {
  // no override and no correct answer means don't grade.
  if (!questionscore && !question.hasCorrectAnswer) {
    return null;
  }

  if (!response) {
    return defaultUngraded(question, questionscore);
  }
  if (response.isCorrect) {
    return defaultCorrect(question, questionscore);
  } else {
    return 0;
  }
};
